"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicSingleNetworkContractStore = void 0;
var events_1 = __importDefault(require("events"));
var erc20_json_1 = __importDefault(require("../default-abis/erc20.json"));
var erc721_json_1 = __importDefault(require("../default-abis/erc721.json"));
var erc1155_json_1 = __importDefault(require("../default-abis/erc1155.json"));
/**
 * Dynamic Contract Store for managing ABIs and deployments on a single network
 */
var DynamicSingleNetworkContractStore = /** @class */ (function (_super) {
    __extends(DynamicSingleNetworkContractStore, _super);
    function DynamicSingleNetworkContractStore(chainId, originalConfig, opts) {
        var _this = _super.call(this) || this;
        _this.abis = {};
        _this.deployments = {};
        _this.chainId = chainId;
        if (!(opts === null || opts === void 0 ? void 0 : opts.withoutDefaultABIs)) {
            _this.registerAbi("ERC20", erc20_json_1.default);
            _this.registerAbi("ERC721", erc721_json_1.default);
            _this.registerAbi("ERC1155", erc1155_json_1.default);
        }
        if (originalConfig.abis) {
            Object.entries(originalConfig.abis).forEach(function (_a) {
                var key = _a[0], abi = _a[1];
                _this.registerAbi(key, abi);
            });
        }
        if (originalConfig.deployments) {
            Object.entries(originalConfig.deployments).forEach(function (_a) {
                var key = _a[0], deployment = _a[1];
                _this.registerDeployment(key, deployment);
            });
        }
        return _this;
    }
    /**
     * Register an ABI
     * @param key String key of the ABI
     * @param abi ABI
     */
    DynamicSingleNetworkContractStore.prototype.registerAbi = function (key, abi) {
        if (this.abis[key]) {
            throw new Error("An ABI already exists for key ".concat(key, " and chain ID ").concat(this.chainId));
        }
        this.abis[key] = abi;
        this.emit("abi/registered", { key: key, abi: abi, chainId: this.chainId });
        return this;
    };
    /**
     * Register a deployment
     * @param key String key of the deployment
     * @param deployment.address Address of the contract
     * @param deployment.abiKey String key of the already registered ABI
     */
    DynamicSingleNetworkContractStore.prototype.registerDeployment = function (key, deployment) {
        if (this.deployments[key]) {
            throw new Error("A deployment already exists for key ".concat(key, " and chain ID ").concat(this.chainId));
        }
        if (!this.abis[deployment.abiKey]) {
            throw new Error("No ABI for key ".concat(key, " and chain ID ").concat(this.chainId, " has been found."));
        }
        this.deployments[key] = deployment;
        this.emit("deployment/registered", {
            key: key,
            deployment: {
                address: deployment.address,
                abiKey: deployment.abiKey,
                chainId: this.chainId,
            },
        });
        return this;
    };
    /**
     * Register a contract, the ABI and address are stored under the provided key
     * @param key Strink key for the address and ABI
     * @param contract.address Address of the contract
     * @param contract.abi ABI of the contract
     */
    DynamicSingleNetworkContractStore.prototype.registerContract = function (key, contract) {
        this.registerAbi(key, contract.abi);
        this.registerDeployment(key, {
            address: contract.address,
            abiKey: key,
        });
        return this;
    };
    /**
     * Update an ABI
     * @param key String key of the ABI
     * @param abi New ABI
     */
    DynamicSingleNetworkContractStore.prototype.updateAbi = function (key, abi) {
        if (!this.abis[key]) {
            throw new Error("No ABI for key ".concat(key, " and chain ID ").concat(this.chainId, " has been found."));
        }
        this.abis[key] = abi;
        this.emit("abi/updated", { key: key, abi: abi, chainId: this.chainId });
        return this;
    };
    /**
     * Update a deployment, only the ABI key can be updated
     * @param key String key of the deployment
     * @param abiKey The new ABI key of the deployment
     */
    DynamicSingleNetworkContractStore.prototype.updateDeployment = function (key, abiKey) {
        if (!this.deployments[key]) {
            throw new Error("No deployment for key ".concat(key, " and chain ID ").concat(this.chainId, " has been found."));
        }
        if (!this.abis[abiKey]) {
            throw new Error("No ABI for key ".concat(key, " and chain ID ").concat(this.chainId, " has been found."));
        }
        this.deployments[key].abiKey = abiKey;
        this.emit("deployment/updated", { key: key, abiKey: abiKey, chainId: this.chainId });
        return this;
    };
    /**
     * Delete a deployment
     * @param key String key of the deployment
     */
    DynamicSingleNetworkContractStore.prototype.deleteDeployment = function (key) {
        var deployment = this.getDeployment(key);
        delete this.deployments[key];
        this.emit("deployment/deleted", { key: key, deployment: deployment, chainId: this.chainId });
        return this;
    };
    /**
     * Delete an ABI, the ABI can not be currently used in a deployment
     * @param key String key of the ABI
     */
    DynamicSingleNetworkContractStore.prototype.deleteAbi = function (key) {
        var abi = this.getAbi(key);
        if (this.isAbiUsed(key)) {
            throw new Error("Unable to delete the abi for key ".concat(key, " on chain ID ").concat(this.chainId, " as it is used in at least one deployment."));
        }
        delete this.abis[key];
        this.emit("abi/deleted", { key: key, abi: abi, chainId: this.chainId });
        return this;
    };
    /**
     * Check if an ABI is used in a deployment
     * @param key String key of the ABI
     * @returns True if the ABI is used in a deployment, false otherwise
     */
    DynamicSingleNetworkContractStore.prototype.isAbiUsed = function (key) {
        return Object.values(this.deployments).some(function (deployment) { return deployment.abiKey === key; });
    };
    /**
     * Get an ABI
     * @param key String key of the ABI
     * @returns The ABI
     */
    DynamicSingleNetworkContractStore.prototype.getAbi = function (key) {
        var abi = this.abis[key];
        if (!abi) {
            throw new Error("No ABI for key ".concat(key, " and chain ID ").concat(this.chainId, " has been found."));
        }
        return abi;
    };
    /**
     * Get a contract by finding the address and ABI
     * @param key String key of the deployment of the contract
     * @returns The address and ABI of the contract
     */
    DynamicSingleNetworkContractStore.prototype.getContract = function (key) {
        var deployment = this.getDeployment(key);
        var abi = this.getAbi(deployment.abiKey);
        return {
            address: deployment.address,
            abi: abi,
        };
    };
    /**
     * Get an address
     * @param key String key of the deployment
     * @returns The address of the deployment
     */
    DynamicSingleNetworkContractStore.prototype.getAddress = function (key) {
        var deployment = this.getDeployment(key);
        return deployment.address;
    };
    /**
     * Get all the addresses
     * @returns The array of addresses
     */
    DynamicSingleNetworkContractStore.prototype.getAddresses = function () {
        return Object.values(this.deployments).map(function (deployment) { return deployment.address; });
    };
    /**
     * Convert the store to an object
     * @returns The store abis and deployments
     */
    DynamicSingleNetworkContractStore.prototype.toObject = function () {
        return {
            abis: this.abis,
            deployments: this.deployments,
        };
    };
    /**
     * Get a deployment
     * @param key String key of the deployment
     * @returns The deployment
     */
    DynamicSingleNetworkContractStore.prototype.getDeployment = function (key) {
        var deployment = this.deployments[key];
        if (!deployment) {
            throw new Error("No deployment for key ".concat(key, " and chain ID ").concat(this.chainId, " has been found."));
        }
        return deployment;
    };
    return DynamicSingleNetworkContractStore;
}(events_1.default));
exports.DynamicSingleNetworkContractStore = DynamicSingleNetworkContractStore;
